import { Copy } from 'lucide-react';
import { toast } from 'sonner';

import { useErrorHandler } from '../hooks/useErrorHandler';

export const CopyToClipboard = ({ text }: { text: string }) => {
  const { handleGeneralAppError } = useErrorHandler();

  return (
    <Copy
      size={16}
      className="text-primary cursor-pointer"
      onClick={() => {
        navigator.clipboard
          .writeText(text)
          .catch(handleGeneralAppError)
          .then(() => {
            toast.info('Copied to clipboard!');
          });
      }}
    />
  );
};
